import React from 'react';
import { ContentBox } from '../ContentBox/ContentBox';
import { LoanTypes } from 'services/loan/type.constansts';

interface IProps {
  loanSelected: any;
  setTaskOpenModal: any;
  tasks: any;
}

export const BoxPropertyDetails: React.FC<IProps> = ({ loanSelected, setTaskOpenModal: openTask, tasks }: IProps) => {

  const dcsrTask = tasks?.find((item: any) => item.key === 'dscr');
  const propertyType = loanSelected?.salesforceData?.property?.propertyType ? loanSelected?.salesforceData?.property?.propertyType : loanSelected?.loanData['What kind of property is it?']
  const unitCount = loanSelected?.salesforceData?.property?.unitCount || dcsrTask?.metadata?.totalUnits || 'unknown';

  return (
    <ContentBox
      label={'Property Details'}
      content={[
        { field: 'Property Type', value: propertyType },
        ...(
          loanSelected?.type === LoanTypes.RENTAL ?
            [
              { field: 'Unit count', value:<>{unitCount} <span onClick={() => openTask('dscr')}>{"View unit info ->"}</span></> },
            ] : []
        )
      ]}
    />
  );
}